// extracted by mini-css-extract-plugin
module.exports = {"productshareIcon":"ShareButton_productshareIcon__2u3Lr","shareTooltip":"ShareButton_shareTooltip__2lk2B"};